/**
 * Normalizes an email address by trimming whitespace and converting it
 * to lowercase. For Gmail and Googlemail addresses, removes periods
 * from the local part of the address.
 *
 * @param {string} email - The email address to normalize.
 * @returns {string} The normalized email address.
 */
export function normalizeEmail(email) {
	email = (email || '').trim().toLowerCase();
	const [local, domain] = email.split('@');
	if (domain === 'gmail.com' || domain === 'googlemail.com') {
		return local.replace(/\./g, '') + '@' + domain;
	}
	return email;
}
